import request from '@/utils/request'

/** 解析 admin 接口统一响应 */
function unwrap<T>(promise: Promise<any>): Promise<T> {
  return promise.then((res: any) => {
    if (String(res.data.code) === '1') {
      return res.data.data as T
    }
    return Promise.reject(new Error((res.data && res.data.msg) || '请求失败'))
  })
}

/** 角色列表 */
export const listMpRoles = () =>
  unwrap(request({ url: '/mp/roles', method: 'get' }))

/** 角色详情 */
export const getMpRole = (id: number) =>
  unwrap(request({ url: `/mp/role/${id}`, method: 'get' }))

/** 新增角色 */
export const createMpRole = (data: {
  roleName: string
  description?: string
  status?: number
  permissionIds?: number[]
}) =>
  unwrap(request({ url: '/mp/role', method: 'post', data }))

/** 编辑角色 */
export const updateMpRole = (data: {
  id: number
  roleName: string
  description?: string
  status?: number
  permissionIds?: number[]
}) =>
  unwrap(request({ url: '/mp/role', method: 'put', data }))

/** 删除角色 */
export const deleteMpRole = (id: number) =>
  unwrap(request({ url: `/mp/role/${id}`, method: 'delete' }))

/** 权限列表 */
export const listMpPermissions = () =>
  unwrap(request({ url: '/mp/permissions', method: 'get' }))

/** 更新角色权限（兼容旧接口） */
export const updateMpRolePermissions = (data: {
  roleId: number
  permissionIds: number[]
}) =>
  unwrap(request({
    url: '/mp/role/permissions',
    method: 'put',
    data
  }))

/** 小程序用户列表 */
export const listMpUsers = () =>
  unwrap(request({ url: '/mp/users', method: 'get' }))

/** 更新用户角色 */
export const updateMpUserRole = (data: {
  openid: string
  nickname?: string
  roleId?: number
  roleIds?: number[]
}) =>
  unwrap(request({
    url: '/mp/user/role',
    method: 'put',
    data
  }))
